import AnyNetworkIcon from '@material-ui/icons/Public';
import { createElement, FC } from 'react';

import { CreativeFormatNetwork } from '../../../generated/graphql';
import AmazonIcon from '../primitive/AmazonIcon';
import AppleIcon from '../primitive/AppleIcon';
import FacebookIcon from '../primitive/FacebookIcon';
import GoogleIcon from '../primitive/GoogleIcon';
import InstagramIcon from '../primitive/InstagramIcon';
import LineIcon from '../primitive/LineIcon';
import OwnedMediaIcon from '../primitive/OwnedMediaIcon';
import SnapchatIcon from '../primitive/SnapchatIcon';
import TwitterIcon from '../primitive/TwitterIcon';
import YahooIcon from '../primitive/YahooIcon';
import YouTubeIcon from '../primitive/YouTubeIcon';

type Props = {
  network: Pick<CreativeFormatNetwork, 'key' | 'name'>;
  size?: number;
  className?: string;
};

const CreativeFormatNetworkIcon: FC<Props> = ({ network, size, className }) => {
  switch (network.key) {
    case 'facebook':
      return <FacebookIcon className={className} size={size} color="#3B5998" />;
    case 'instagram':
      return <InstagramIcon className={className} size={size} />;
    case 'snapchat':
      return <SnapchatIcon className={className} size={size} />;
    case 'youtube':
      return <YouTubeIcon className={className} size={size} />;
    case 'twitter':
      return <TwitterIcon className={className} size={size} />;
    case 'line':
      return <LineIcon className={className} size={size} />;
    case 'yahoo':
      return <YahooIcon className={className} size={size} />;
    case 'google':
      return <GoogleIcon className={className} size={size} />;
    case 'apple':
      return <AppleIcon className={className} size={size} />;
    case 'amazon':
      return <AmazonIcon className={className} size={size} />;
    case 'owned_media':
      return <OwnedMediaIcon className={className} size={size} />;
    case 'other':
    case 'any_network':
      return <AnyNetworkIcon className={className} style={{ width: size, height: size }} />;
    default:
      return <div>{network.name}</div>;
  }
};

export default CreativeFormatNetworkIcon;
